(() => {
  function init(root) {
    if (root.dataset.bReady) return;
    root.dataset.bReady = 'true';
    root.dataset.bActive = 'all';
    const filters = root.querySelector('[data-b-filters]');
    const cards = [...root.querySelectorAll('[data-b-category]')];
    const count = root.querySelector('[data-b-count]');
    if (!filters || !cards.length) return;
    filters.hidden = false;
    filters.addEventListener('click', event => {
      const button = event.target.closest('[data-b-filter]');
      if (!button) return;
      const category = button.dataset.bFilter;
      root.dataset.bActive = category;
      filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      let visible = 0;
      cards.forEach(card => {
        const shown = category === 'all' || category === card.dataset.bCategory;
        card.closest('.fw-b-grid__item').hidden = !shown;
        if (shown) visible++;
      });
      if (count) count.textContent = count.textContent.replace(/\d+/, String(visible));
    });
  }
  document.querySelectorAll('[data-burgundy-root]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-burgundy-root]').forEach(init));
  if (!customElements.get('fw-burgundy-note')) customElements.define('fw-burgundy-note', class extends HTMLElement {
    connectedCallback() {
      this.ids = new Set((this.dataset.ids || '').split(','));
      this.root = this.closest('[data-pdp-root]') || this.closest('.fw-pdp') || this.closest('section');
      if (!this.root) return;
      this.sync = () => requestAnimationFrame(() => {
        const input = this.root.querySelector('[data-pdp-variant-id]');
        if (input) this.hidden = !this.ids.has(input.value);
      });
      this.root.addEventListener('click', this.sync);
      this.root.addEventListener('change', this.sync);
      this.sync();
    }
    disconnectedCallback() {
      this.root?.removeEventListener('click', this.sync);
      this.root?.removeEventListener('change', this.sync);
    }
  });
})();
